interface PatientRemoteCareConversionProps {
    actionId: string;
}

const PatientRemoteCareConversionStep: React.FC<PatientRemoteCareConversionProps> = ({
    actionId,
}) => {
    if (!actionId) {
        return <div className="text-danger">Action ID is required.</div>;
    }
    return (
        <div className="bg-white p-3 w-100">
            <iframe
                src={`patient/remote_care_conversion?actionId=${actionId}`}
                title="Remote Care Conversion"
                style={{ width: "100%", height: "100vh", border: "none" }}
                loading="lazy"
            />
        </div>
    );
};

export default PatientRemoteCareConversionStep;
